import { Card, Text, Flex, Box } from '@mantine/core';
import { Avatar } from '@dealstack/frontend/shared/components/Avatar/Avatar';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';

interface Props {
	name: string;
	email: string;
}

export const ProfileCard = ({ name, email }: Props) => {
	return (
		<Card
			padding="sm"
			miw={310}
			maw={420}
			bg="gray.0"
			sx={(theme) => ({
				border: `1px solid ${theme.colors.gray[2]}`,
				borderRadius: '0.5rem',
			})}
		>
			<Flex gap="1rem" align="center" justify="flex-start">
				{name ? (
					<Box data-testid="avatar-with-initials">
						<Avatar size="xl" children={name} />
					</Box>
				) : (
					<Box data-testid="avatar-with-icon">
						<Avatar
							size="xl"
							children={<Icon dataTestId="user-icon" variant="user" size="xl" />}
						/>
					</Box>
				)}
				<Flex direction="column" gap="0.5rem">
					{name && (
						<Text size="sm" c="dark.8" fw={500}>
							{name}
						</Text>
					)}
					<Text size="sm" c="dark.0">
						{email}
					</Text>
				</Flex>
			</Flex>
		</Card>
	);
};
